import {
  branch,
  compose,
  defaultProps,
  renderComponent,
  withState
} from 'recompose'

const SelectContainer = ({ NativeComponent, DefaultComponent }) =>
  compose(
    defaultProps({
      native: true // set true if you want a vanilla select box
    }),
    branch(({ native }) => native, renderComponent(NativeComponent)),
    withState('open', 'setOpen', false)
  )(DefaultComponent)

export default SelectContainer
